import { ContentWrapper } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  workorderComplementColor,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useWindowSize } from '@/hooks';
import { Col, Divider, Row } from 'antd';
import WorkOrdersClosedMonth from './WorkOrdersClosedMonth';
import WorkOrdersClosedTotal from './WorkOrdersClosedTotal';

interface Props {
  workOrderValueClosedMonth?: number;
  workOrderValueTotal?: number;
}

function WorkOrderClosed({
  workOrderValueClosedMonth,
  workOrderValueTotal,
}: Props) {
  const { width } = useWindowSize();

  return (
    <ContentWrapper
      style={{ padding: '16px' }}
      extraStyle={{ top: '10px', right: '8px' }}
    >
      <StatusTag
        size="lg"
        label="Fechado"
        color={workorderComplementColor[WorkOrderComplementStatus.Closed]}
      />

      <Row gutter={[12, 12]} style={{ marginTop: 8 }}>
        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersClosedMonth value={workOrderValueClosedMonth || 0} />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <Divider
            type={width >= 1707 ? 'vertical' : 'horizontal'}
            style={{ height: '100%', margin: 0 }}
          />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersClosedTotal value={workOrderValueTotal || 0} />
        </Col>
      </Row>
    </ContentWrapper>
  );
}

export default WorkOrderClosed;
